import React from 'react';
import { X } from '../../design-system/icons';

interface EditableListProps {
  values: string[];
  onChange: (values: string[]) => void;
  addLabel: string;
}

/** Generic editable string list — used for Do's / Don'ts in CampaignEditForm. */
export function EditableList({ values, onChange, addLabel }: EditableListProps) {
  const [draft, setDraft] = React.useState('');

  const add = () => {
    const trimmed = draft.trim();
    if (!trimmed) return;
    onChange([...values, trimmed]);
    setDraft('');
  };
  const removeAt = (i: number) => onChange(values.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2">
      {values.map((item, i) => (
        <div key={i} className="flex items-center gap-2 rounded-lg bg-muted px-3 py-2.5">
          <span className="flex-1 text-body-sm-regular text-foreground">{item}</span>
          <button type="button" onClick={() => removeAt(i)} className="text-muted-foreground hover:text-foreground">
            <X size={14} weight="bold" />
          </button>
        </div>
      ))}
      <div className="flex gap-2">
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
          placeholder={addLabel}
          className="min-w-0 flex-1 rounded-lg border border-border bg-transparent px-3 py-2 text-body-sm-regular text-foreground placeholder:text-muted-foreground"
        />
        <button
          type="button"
          onClick={add}
          className="shrink-0 rounded-lg border border-border px-3 py-2 text-body-sm-medium text-foreground hover:border-foreground"
        >
          Add
        </button>
      </div>
    </div>
  );
}
